import { Search } from 'lucide-react'
import { Input } from '@teach/ui'
import type { Instruction } from '@/features/instructions/types'
import { useArticlePickerList } from '../hooks/useArticlePickerList'
import { ArticlePickerResults } from './ArticlePickerResults'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  selectedId: number | null
  /** Клик по статье — сразу выбор, без «Подтвердить» и без окна. */
  onPick: (articleId: number, article: Instruction) => void
  /** Обёртка пустого состояния (см. `ArticlePickerResults`). */
  emptyClassName?: string
}

/** Выбор статьи прямо в панели блока: поиск и карточки в две колонки. */
export const ArticleInlinePicker = ({ selectedId, onPick, emptyClassName }: Props) => {
  const list = useArticlePickerList()
  const m = useMessages(messages)
  return (
    <div>
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 size-4 text-muted-foreground" />
        <Input
          value={list.searchInput}
          onChange={(e) => list.setSearchInput(e.target.value)}
          placeholder={m.searchPlaceholder}
          className="pl-9"
        />
      </div>
      <ArticlePickerResults
        isLoading={list.isLoading}
        isError={list.isError}
        items={list.items}
        debouncedQ={list.debouncedQ}
        selectedId={selectedId}
        onSelect={(id) => {
          const article = list.items.find((i) => i.id === id)
          if (article) onPick(id, article)
        }}
        emptyClassName={emptyClassName}
      />
    </div>
  )
}
